/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Базовый вид для загрузки и валидации фотографий
   */
  app.UploadPhotoFormView = app.FormView.extend({
    formElement: '.field',
    fileSizeLimit: 2097152,
    fileTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
    photoTemplateId: '',
    additionalOptions: ['photoTemplateId'],
    /**
     * @inheritDoc
     */
    beforeRun: function () {
      this.photoTemplate = app.helpers.TemplateHelper.getTemplate(this.photoTemplateId);
      this.filesData = [];
    },

    /**
     * Валидация фотографий
     * @inheritDoc
     */
    _validateFile: function (file) {
      var $caption = this.$('.photo-caption');
      if (file.size > this.fileSizeLimit || this.fileTypes.indexOf(file.type) === -1) {
        $caption.removeClass('not_display');
        return false;
      }
      if (!$caption.hasClass('not_display')) {
        $caption.addClass('not_display');
      }
      return true;
    },

    /**
     * @inheritDoc
     */
    _renderFilePreview: function (file, itemId) {
      var $thumbnails = this.$('.photo-thumbnails'),
        url = window.URL.createObjectURL(file);
      $thumbnails.append($(this.photoTemplate({
        id: itemId,
        url: url,
      })));
    },

    /**
     * @inheritDoc
     */
    prepareToUpload: function (file, itemId) {
      if (!this._validateFile(file)) {
        return;
      }
      this._renderFilePreview(file, itemId);
      this.filesData.push(file);
    },

    /**
     * Удаление загруженных фотографий c сервера
     * @param {Array} id
     */
    deletePhotos: function (id) {
      $.ajax({
        url: this.uploadOptions.urlRoot + id + '/',
        method: 'DELETE',
      });
    }
  });
})(jQuery);

}.call(window));